module.exports = __webpack_public_path__ + "static/media/alexandra.07bffb40.JPG";